import dotProps from 'dot-prop-immutable';

import * as actionTypes from './actiontypes';
import states from './states';

export default function botbuilder_details(state = states.botbuilder_details, action) {
    switch (action.type) {
        case actionTypes.UPDATE_BOT_BUILDER_STATE: {
            return dotProps.set(state, action.path, action.payload);
        }

        case actionTypes.DELETE_BOT_BUILDER_STATE: {
            return dotProps.delete(state, action.path);
        }

        case actionTypes.PREEMPTIVE_DATA_LOADED: {
            return {
                ...state,
                preemptive_data: {
                    ...state.preemptive_data,
                    actions: action.payload.actions ? action.payload.actions : [...state.preemptive_data.actions],
                    variables: action.payload.variables ? action.payload.variables : [...state.preemptive_data.variables],
                    messages: action.payload.messages ? action.payload.messages : [...state.preemptive_data.messages],
                    event_tags: action.payload.eventTags ? action.payload.eventTags : [...state.preemptive_data.eventTags],
                    event_types: action.payload.eventTypes ? action.payload.eventTypes : [...state.preemptive_data.eventTypes]
                }
            };
        }

        case actionTypes.WORK_FLOW_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    workflows_loading: true,
                    workflows_loaded: false
                }
            };
        }

        case actionTypes.WORK_FLOW_LOADED: {
            return {
                ...state,
                workflows: action.payload && action.payload.workflowData ? action.payload.workflowData : [...state.workflows],
                loaders: {
                    ...state.loaders,
                    workflows_loading: false,
                    workflows_loaded: true
                }
            };
        }

        case actionTypes.WORK_FLOW_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    workflows_loading: false,
                    workflows_loaded: false
                }
            };
        }

        case actionTypes.WORK_FLOW_DELETED: {
            let index = -1;
            index = state.workflows.findIndex((workflow) => {
                return (workflow.wid === action.payload.wid)
            });

            return {
                ...state,
                workflows: index !== -1 ? [...state.workflows.slice(0, index), ...state.workflows.slice(index + 1)] : [...state.workflows],
            };
        }

        case actionTypes.WORK_FLOW_UPDATED: {
            let index = -1;
            index = state.workflows.findIndex((workflow) => {
                return (action.payload.updatedWorkflow && action.payload.updatedWorkflow.wid === workflow.wid)
            });

            return {
                ...state,
                workflows: index !== -1 ? [...state.workflows.slice(0, index), { ...state.workflows[index], ...action.payload.updatedWorkflow }, ...state.workflows.slice(index + 1)] : [...state.workflows],
            };
        }

        case actionTypes.WORK_FLOW_CREATED: {
            return {
                ...state,
                workflows: action.payload.workflow ? [action.payload.workflow, ...state.workflows] : [...state.workflows],
            };
        }

        case actionTypes.WORK_FLOW_MODEL_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    workflow_model_loading: true,
                    workflow_model_loaded: false,
                }
            };
        }

        case actionTypes.WORK_FLOW_MODEL_LOADED: {
            return {
                ...state,
                workflow_model: action.payload.UIRepresentation,
                workflow_model_title: action.payload.name ? action.payload.name : "workflow diagram",
                loaders: {
                    ...state.loaders,
                    workflow_model_loading: false,
                    workflow_model_loaded: true,
                }
            };
        }

        case actionTypes.WORK_FLOW_MODEL_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    workflow_model_loading: false,
                    workflow_model_loaded: false,
                }
            };
        }

        case actionTypes.RESET_WORK_FLOW_MODEL: {
            return {
                ...state,
                workflow_model: [],
                workflow_model_title: "workflow diagram"
            };
        }

        case actionTypes.UPDATE_WORK_FLOW_MODEL: {
            return {
                ...state,
                workflow_model: action.payload,
            };
        }

        case actionTypes.WORK_FLOW_DIAGRAM_SAVED: {
            return {
                ...state,
                workflow_model: action.payload.updatedWorkflow && action.payload.updatedWorkflow.UIRepresentation ? action.payload.updatedWorkflow.UIRepresentation : [...state.workflow_model],
                workflow_model_title: action.payload.updatedWorkflow && action.payload.updatedWorkflow.name ? action.payload.updatedWorkflow.name : "workflow diagram",
            };
        }

        case actionTypes.WORK_FLOW_NODE_DETAILS_LOADED: {
            return {
                ...state,
                active_workflow_node_details: action.payload.nodeDetails,
                active_node_possible_rules: action.payload && action.payload.possibleRules ? action.payload.possibleRules : [],
            };
        }

        case actionTypes.CLEAR_WORK_FLOW_NODE_DETAILS: {
            return {
                ...state,
                active_workflow_node_details: {
                    message_before: [],
                    message_after: []
                },
                active_node_possible_rules: [],
            };
        }

        case actionTypes.WORKFLOW_DIAGRAM_NODE_CHANGING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    workflow_diagram_node_changing: true,
                }
            };
        }

        case actionTypes.ENTITY_TYPE_NODE_CREATED: {
            let workflow_model = [...state.workflow_model];

            if (action.payload.parentNode) {
                const index = workflow_model.findIndex((model) => { return model.id === action.payload.parentNode.id });
                if (index !== -1) {
                    workflow_model = [...state.workflow_model.slice(0, index), action.payload.parentNode, ...state.workflow_model.slice(index + 1)]
                }
            }

            if (action.payload.createdNode) {
                workflow_model = [...workflow_model, action.payload.createdNode];
            }

            return {
                ...state,
                workflow_model,
                loaders: {
                    ...state.loaders,
                    workflow_diagram_node_changing: false,
                }
            };
        }

        case actionTypes.ENTITY_TYPE_NODE_UPDATED: {
            let workflow_model = [...state.workflow_model];

            if (action.payload.updatedNode) {
                const index = workflow_model.findIndex((model) => { return model.id === action.payload.updatedNode.id });
                if (index !== -1) {
                    workflow_model = [
                        ...workflow_model.slice(0, index),
                        {
                            ...workflow_model[index],
                            ...action.payload.updatedNode
                        },
                        ...workflow_model.slice(index + 1)
                    ];
                }
            }

            return {
                ...state,
                workflow_model,
                loaders: {
                    ...state.loaders,
                    workflow_diagram_node_changing: false,
                }
            };
        }

        case actionTypes.WORKFLOW_TYPE_NODE_CREATED: {
            let workflow_model = [...state.workflow_model];

            if (action.payload.parentNode) {
                const index = workflow_model.findIndex((model) => { return model.id === action.payload.parentNode.id });
                if (index !== -1) {
                    workflow_model = [...state.workflow_model.slice(0, index), action.payload.parentNode, ...state.workflow_model.slice(index + 1)]
                }
            }

            if (action.payload.createdWorkflow) {
                workflow_model = [...workflow_model, action.payload.createdWorkflow];
            }

            return {
                ...state,
                workflow_model,
                loaders: {
                    ...state.loaders,
                    workflow_diagram_node_changing: false,
                }
            };
        }

        case actionTypes.WORKFLOW_TYPE_NODE_UPDATED: {
            return {
                ...state,
                workflow_model: action.payload && action.payload.UIRepresentation ? action.payload.UIRepresentation : [...state.workflow_model],
                loaders: {
                    ...state.loaders,
                    workflow_diagram_node_changing: false,
                }
            };
        }

        case actionTypes.WORKFLOW_DIAGRAM_NODE_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    workflow_diagram_node_changing: false,
                }
            };
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/redux/botbuilder_details/reducers.js